<template>
  <div class="orderList">
    <div class="orderList_header">
      <div class="username_box">
        <p>
          <span style="color: #999">取货人云号：</span
          >{{ orderInfoList.orderName }}
        </p>
        <img
          src="@/assets/order/copy.png"
          alt="复制"
          @click="handleCopyUserName(orderInfoList.orderName)"
          style="cursor: pointer"
        />
      </div>
      <div class="time_box">
        <p>{{ orderInfoList.createTime }}</p>
      </div>
    </div>
    <div class="orderList_main">
      <div class="orderList_main-left">
        <ul>
          <li v-for="(item, index) in orderInfoList.items" :key="index">
            <div class="info_box">
              <div class="img_box">
                <img :src="item.snapshotImg" alt="" />
              </div>
              <div class="content_box">
                <p class="name_p" :title="item.productName">
                  {{ item.productName }}
                </p>
              </div>
            </div>
            <div class="num_box">
              <span>x{{ item.amount }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="orderList_main-right">
        <div class="peopleInfo">
          <el-popover placement="top-start" width="200" trigger="hover">
            <p style="color: #222; font-weight: bold">
              {{ orderInfoList.recipients }}
            </p>
            <p>{{ orderInfoList.address }}</p>
            <p>{{ orderInfoList.mobile }}</p>
            <span slot="reference">收货人信息</span>
          </el-popover>
        </div>
        <div class="price_box">
          <p>￥{{ handleToFixed2(orderInfoList.totalPrice) }}</p>
          <p style="color: #2771fa; padding-top: 10px; font-weight: normal">
            {{ orderInfoList.paymentWayValue || "未知" }}
          </p>
        </div>
        <div class="state_box">
          <span class="red" v-show="orderInfoList.orderStatus == 0"
            >待出库</span
          >
          <span class="blue" v-show="orderInfoList.orderStatus == 1"
            >待出售</span
          >
          <span class="green" v-show="orderInfoList.orderStatus == 2"
            >已出售</span
          >
          <span style="color: #999" v-show="orderInfoList.orderStatus == 3"
            >已取消</span
          >
          
          <el-tag v-if="orderInfoList.isCollectMoney==1" style="margin-top: 10px;color: #FC9F50;display: flex;align-items: center;justify-content: space-around;" type="warning">
           <svg t="1660546290273" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2715" width="12" height="12"><path d="M748.1344 86.016v556.032h95.0272L512 918.1184 180.8384 642.048h95.0272V86.016h472.2688m65.536-65.536H210.3296v556.032H0L512 1003.52l512-427.008H813.6704V20.48z" p-id="2716" fill="#FC9F50"></path><path d="M662.1184 324.1984H361.8816v65.3312h300.2368v-65.3312zM662.1184 463.0528H361.8816V528.384h300.2368v-65.3312z" p-id="2717" fill="#FC9F50"></path><path d="M544.768 341.6064h-65.536v300.2368h65.536V341.6064z" p-id="2718" fill="#FC9F50"></path><path d="M594.944 185.7536L512 268.6976l-82.944-82.944-46.08 46.2848 113.0496 113.2544 15.9744-15.9744 15.9744 15.9744 113.0496-113.2544-46.08-46.2848z" p-id="2719" fill="#FC9F50"></path></svg>  
            <span style="margin-left: 5px;">财务已收款</span></el-tag>
        </div>
        <div class="orderCode_box">
          <p class="code_p">
            <span>{{ orderInfoList.orderCode }}</span>
            <img
              src="@/assets/order/copy.png"
              alt="复制"
              @click="handleCopyUserName(orderInfoList.orderCode)"
              style="cursor: pointer"
            />
          </p>
          <p class="remarks_p" :title="orderInfoList.notices">
            {{ orderInfoList.notices || "--" }}
          </p>
        </div>
        <div class="operation_box">
          <p
            @click="handleExwarehouse(orderInfoList.orderCode)"
            v-show="orderInfoList.orderStatus == 0&&orderInfoList.isCollectMoney==1"
          >
            出库
          </p>
          <p
            @click="handleExwarehouse(orderInfoList.orderCode)"
            v-show="orderInfoList.orderStatus == 0&&orderInfoList.paymentWayValue!='货到付款'"
          >
            出库
          </p>
          <!-- isThreeLine true  三线至尊 -->
          <p @click="showHandleSell" v-show="orderInfoList.orderStatus == 1&& !orderInfoList.isThreeLine">
            出售
          </p>
          <p @click="handleSelectInfo" v-if="orderInfoList.orderStatus == 3">
            查看原因
          </p>
          <p @click="handleSelectInfo" v-else>查看详情</p>
          <p
          style="color: #FF7307;font-weight: bold;"
            v-show="orderInfoList.orderStatus == 0&&orderInfoList.isCollectMoney!=1&&orderInfoList.paymentWayValue=='货到付款'"
            @click="collectionMoney(orderInfoList)"
          >
            收款确认
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="insufficientFlag"
      width="274px"
      class="insufficient_dialog"
    >
      <div class="insufficient_content">
        <img src="@/assets/order/gth.png" alt="库存不足" />
        <p>库存不足</p>
        <button class="know_button" @click="handleKnow">知道了</button>
      </div>
    </el-dialog>
    <el-dialog
      title="取消原因"
      :visible.sync="cancelReasonFlag"
      width="366px"
      class="cancelReasonFlag_dialog"
    >
      <div class="cancelReasonFlag_content">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入内容"
          v-model="cancelReasonValue"
        >
        </el-input>
        <div class="btn_box">
          <button class="cancel_button" @click="handleCancelCancel">
            取消
          </button>
          <button class="sure_button" @click="handleCancelSure">确定</button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="收款确认"
      :visible.sync="collectionMoneyDiloag"
      width="374px"
      :close-on-click-modal="false"
      class="insufficient_dialogs"
    >
      <p class="title">请核对此订单是否已实时到账!</p>
      <p class="waring">谨慎操作!!</p>
      <div class="btn_box">
        <el-button class="cancel_button" @click="collectionMoneyDiloag = false">
          取消
        </el-button>
        <el-button class="sure_button" @click="confromCollectionMoney">
          确定
        </el-button>
      </div>
    </el-dialog>
    <hadleSellVue ref="hadSell"/>
  </div>
</template>

<script>
import { handleToFixed2, handleCopy } from "@/util/common";
import { sellApi, collectMoneyConfirm } from "@/api/order";
import hadleSellVue from "./hadleSell.vue";
export default {
  name: "OrderList",
  props: {
    orderInfoList: {
      type: Object,
    },
  },
  components:{
    hadleSellVue
  },
  data() {
    return {
      // 库存不足弹窗
      insufficientFlag: false,
      //   取消原因原因弹窗
      cancelReasonFlag: false,
      cancelReasonValue: "",
      // 确认收款弹窗
      collectionMoneyDiloag: false,
      orderCodeVal: "",
    };
  },
  methods: {
    // 显示确认收款弹窗
    collectionMoney(val) {
      this.orderCodeVal = val.orderCode;
      this.collectionMoneyDiloag = true;
    },
    // 确定确认收款
    confromCollectionMoney() {
      collectMoneyConfirm({ orderCode: this.orderCodeVal }).then((res) => {
        if(res.success){
          this.$message.success("收款成功!")
          this.$emit("handleRefreshList");
          this.collectionMoneyDiloag = false
        }else{
          this.collectionMoneyDiloag = false
          this.$message.warning(res.message)
        }
      });
    },
    // 复制云号
    handleCopyUserName(content) {
      if (handleCopy(content)) {
        this.$message({
          type: "success",
          message: "复制成功",
        });
      }
    },
    // 保留两位小数
    handleToFixed2: handleToFixed2,
    // 出库
    handleExwarehouse(val) {
      this.$router.push({
        path: "/stock/outhousing",
        query: { orderCode: val },
      });
    },
    // 出售弹窗
    showHandleSell(){
      this.$refs.hadSell.show()
    },
    // 出售
    async handleSell() {
      let data = await sellApi(
        this.orderInfoList.orderCode,
        this.$store.state.username
      );
      if (data.code == 0) {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.$emit("handleRefreshList");
      } else {
        this.$message({
          type: "error",
          message: data.message,
        });
      }
    },
    // 查看详情
    handleSelectInfo() {
      this.$router.push({
        path: "/orderDeatile",
        query: { orderCode: this.orderInfoList.orderCode },
      });
    },
    // 知道了
    handleKnow() {
      this.insufficientFlag = false;
    },
    // 取消输入取消原因
    handleCancelCancel() {
      this.cancelReasonFlag = false;
      this.cancelReasonValue = "";
    },
    // 确认取消
    handleCancelSure() {},
  },
};
</script>

<style lang="scss">
.orderList {
  border: 1px solid #e7ecf7;
  opacity: 1;
  border-radius: 8px;
  width: 99%;
  margin-bottom: 12px;
  .orderList_header {
    height: 38px;
    background: #f9fbff;
    opacity: 1;
    border-radius: 8px 8px 0px 0px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 26px;
    box-sizing: border-box;
    .username_box {
      display: flex;
      p {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #222222;
        margin-right: 8px;
      }
    }
    .time_box {
      p {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #222222;
      }
    }
  }
  .orderList_main {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 0 30px 20px;
    .orderList_main-left {
      ul {
        height: 100%;
      }
      li {
        padding-top: 20px;
        display: flex;
        height: 68px;
      }
      .info_box {
        display: flex;
        width: 470px;
        height: 100%;
        .img_box {
          width: 68px;
          height: 68px;
          margin-right: 14px;
          img {
            height: 100%;
            width: 100%;
            border-radius: 8px;
          }
        }
        .content_box {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name_p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;

            color: #222222;
            display: -webkit-box;

            -webkit-box-orient: vertical;

            -webkit-line-clamp: 2;

            overflow: hidden;
          }
          .remarks_p {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;

            color: #999999;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .num_box {
        height: 100%;
        width: 200px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #222222;
      }
    }
    .orderList_main-right {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
      .peopleInfo {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #222222;
        cursor: pointer;
      }

      .price_box {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ff7307;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .state_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        .red {
          color: #f83030;
        }
        .blue {
          color: #2771fa;
        }
        .green {
          color: #3aa514;
        }
      }

      .orderCode_box {
        width: 170px;
        .code_p {
          span {
            display: inline-block;
            padding-right: 5px;
          }
          padding-bottom: 5px;
        }
        .remarks_p {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;

          color: #999999;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .operation_box {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2771fa;
        p {
          padding: 15px 0;
          cursor: pointer;
        }
      }
    }
  }
  .insufficient_dialogs{
    .btn_box{
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      .sure_button{
        width: 80px;
        height: 32px;
        line-height: 0;
        background: #2771fa;
        color: #fff;
        margin-left: 10px;
        border-radius: 4px;
      }
      .cancel_button{
        width: 80px;
        height: 32px;
        line-height: 0;
        border-radius: 4px;
        margin-right: 10px;
      }
    }
    .title{
      font-size: 17px;
      font-weight: bold;
      margin:10px 0 0 0 ;
      text-align: center;
    }
    .waring{
      font-size: 17px;
      font-weight: bold;
      color: #f83030;
      margin: 15px 0;
      text-align: center;
    }
      .el-dialog__body {
      padding: 0;
    }
     .el-dialog__title {
      font-weight: bold;
    }
  }
  .insufficient_dialog {
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-weight: bold;
    }
    .insufficient_content {
      text-align: center;
      img {
        margin-bottom: 16px;
      }
      p {
        margin-bottom: 50px;
      }
    }
    .know_button {
      width: 80px;
      height: 32px;
      background: #2771fa;
      opacity: 1;
      border-radius: 4px;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ffffff;
      border: none;
      margin-bottom: 20px;
    }
  }
  .cancelReasonFlag_dialog {
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-weight: bold;
    }
    .cancelReasonFlag_content {
      box-sizing: border-box;
      padding: 15px 30px;
    }
    .btn_box {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-top: 25px;
      button {
        width: 80px;
        height: 32px;
        border: none;
        box-sizing: border-box;
        border-radius: 4px;
      }
      .cancel_button {
        color: #333333;
        border: 1px solid #d8d8d8;
        background: #fff;
      }
      .sure_button {
        background: #2771fa;
        color: #fff;
      }
    }
  }
}
</style>